import React from 'react';
import Main from './components/main/Main';

const App = () => {
  return (
    <Main/>
  );
}

export default App;
